import { GameTag } from '../../../http/protocol';

/**
 * Convert array of GameTag objects to comma-separated string of nameIds
 */
export const gameTagsToString = (tags: GameTag[] | null | undefined): string =>
  !tags?.length
    ? ""
    : tags
        .map(tag => tag.nameId)
        .filter((nameId): nameId is string => Boolean(nameId))
        .join(",");

/**
 * Convert comma-separated string of nameIds to array of GameTag objects
 */
export const gameTagsFromString = (
  gameTagsString: string | null | undefined,
  availableTags: GameTag[] | null | undefined
): GameTag[] => {
  if (!gameTagsString || !availableTags) return [];
  const nameIds = gameTagsString
    .split(",")
    .map(nameId => nameId.trim())
    .filter(Boolean);
  return availableTags.filter(tag => nameIds.includes(tag.nameId ?? ""));
};

/**
 * Get selected nameIds from GameTag array
 */
export const getSelectedGameTagNameIds = (
  tags: GameTag[] | null | undefined
): string[] =>
  !tags?.length
    ? []
    : tags
        .map(tag => tag.nameId)
        .filter((nameId): nameId is string => Boolean(nameId));

/**
 * Find GameTag objects by nameIds
 */
export const findGameTagsByNameIds = (
  nameIds: string[] | null | undefined,
  availableTags: GameTag[] | null | undefined
): GameTag[] =>
  !nameIds?.length || !availableTags?.length
    ? []
    : nameIds
        .map(nameId => availableTags.find(tag => tag.nameId === nameId))
        .filter((tag): tag is GameTag => tag !== undefined);
